import { render, staticRenderFns } from "./ShippingAdressForm.vue?vue&type=template&id=394ab4aa&"
import script from "./ShippingAdressForm.vue?vue&type=script&lang=js&"
export * from "./ShippingAdressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports